<style lang="css">
.phone {
    padding-top: 50px;
    padding-left: 39px;
    padding-right: 38px;
    padding-bottom: 180px;
    left: 50%;
    top: 0;
    height: 800px;
    width: 421px;
    background: url(https://img.alicdn.com/tfs/TB1nlugQFXXXXbuXpXXXXXXXXXX-910-1642.png) no-repeat top;
    -webkit-background-size: 100% 100%;
    margin-left: auto;
    margin-right: auto;

}

</style>

<template lang="html">

<div class="">
    <el-row>
      <el-col>
        <el-input style="width:350px;" v-model="query.keyword" placeholder="请输入搜索关键字"></el-input>
        <el-button type="primary" @click="findBuriedPointEventDatas()">搜索</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top:10px;">
        <div style="float:left;width:70%;">
          <div style="height: 800px;overflow: auto;">
            <el-card v-for="(item,index) in datas">

              <div v-if="item.userInfo" style="float:left;">
                <p v-if="item.userInfo.userHead">
                  <img :src="item.userInfo.userHead" style="width:40px;height:40px;" alt="">
                </p>
                <img :src="item.userInfo.userHead" v-else style="width:40px;height:40px;" alt="">

              </div>

              <div style="float:left;margin-left:30px;">

                <div v-if="item.userInfo&&item.userInfo.phone">{{item.userInfo.phone}} {{item.userInfo.nickname}}</div>
                <p  v-else>匿名标识： <span v-if="item.userInfo">{{item.userInfo.id}}</span> </p>

                <p v-if="item.locations&&item.locations.length>0">
                  页面： <el-tag  style="margin-right:10px;" type="success"  size="mini" v-for="tag in item.locations">{{tag}}</el-tag>
                </p>

                <p v-if="item.actions&&item.actions.length>0">
                    行为： <el-tag  style="margin-right:10px;" type="danger"  size="mini" v-for="tag in item.actions">{{tag}}</el-tag>
                </p>

                <p style="margin-top:1px;">{{item.startTime|dateTimeFormat}} - {{item.endTime|dateTimeFormat}}   </p>
              </div>

              <el-button type="danger" size="mini"  style="float:right;margin-left:10px;"   v-confirm :confirm-text="'确认删除该视频？'" requestUrl="main/delVideo.action" :confirm-data="{id:item._id}" @onConfirm="findBuriedPointEventDatas()">删除</el-button>

              <el-button size="mini" :type="playPosition==index?'danger':'success'" style="float:right;margin-left:10px;" @click="replay(item,index)">{{playPosition==index?'播放中':'播放'}}</el-button>

            </el-card>
          </div>

            <el-pagination
              style="margin-top:20px;padding-left:0px;"
              @current-change="handleCurrentChange"
              :current-page.sync="pageNum"
              :page-sizes="[100, 200, 300, 400]"
              :page-size="10"
              layout="prev, pager, next"
              :total="totalSize">
            </el-pagination>
        </div>

        <el-col style="float:right;width:25%;border-left:#eee solid 1px;border-left:1px solid rgb(238, 238, 238);" >
          <!-- <div class="phone"> -->
            <!-- <div id="iframe" v-loading="mobileLoding"  style="width:100%;height:800px;">

            </div> -->
            <controller @onFinish="onFinish" ref="player"></controller>

          <!-- </div> -->

          <!-- <mobile v-loading="mobileLoding"  element-loading-text="页面分析中..." ref="mobile" style="height:800px;" @onEdit="onEdit"></mobile> -->
        </el-col>
    </el-row>

    <save-x-path-dialog ref="save-x-path-dialog"></save-x-path-dialog>

</div>

</template>

<script>
import SaveXPathDialog from './children/SaveXPathDialog'
import sysModel from '@/framework/models/sysModel'
import BasicModel from '@/framework/basic/BasicModel'
import echarts from 'echarts'
import mobile from './children/mobile'
import controller from './children/controller'
export default {
  name: 'analysis',
  data: function () {
    return {
      query: {
        keyword: null
      },
      type: '近一周',
      createTime: null,
      module: '本地汽车网',
      options: [],
      position: null,
      times: [],
      datas: [],
      mobileLoding: false,
      pageNum: 1,
      pageSize: 10,
      totalSize: 0,
      playPosition: null

    }
  },
  components: {
    mobile,
    SaveXPathDialog,
    controller
  },
  watch: {
    // position: function() {
    //   this.findBuriedPointEventDatas()
    //
    //   //改变页面展示
    //
    //   let option = this.options[this.position]
    //   this.$refs['mobile'].go(option.href)
    // },
    createTime: function (createTime) {
      if (!createTime) {
        this.chart.clear()
        return
      }

      let arr = this.getXAxis({
        tab: 0,
        startTime: this.createTime[0].getTime(),
        endTime: this.createTime[1].getTime()
      })
      this.times = arr
      this.findBuriedPointEventDatas()
    },
    type: function () {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * (this.type == '近一周' ? 7 : 30))
      this.createTime = [start, end]
    }
  },
  mounted: function () {
    let _this = this
    const end = new Date()
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * (this.type == '近一周' ? 7 : 30))
    end.setTime(end.getTime())

    let arr = this.getXAxis({
      tab: 0,
      startTime: start.getTime(),
      endTime: end.getTime()
    })

    this.createTime = [start, end]

    this.times = arr
    // this.init('clue-data-trend-pic')
    this.getBuriedPointInfo()

    self.addEventListener('message', function (event) {
      if (!event) {
        return
      }
      let data = event.data

      switch (data.command) {
        case 'changePage':

          if (!event.data.location) {
            return
          }

          _this.$refs['mobile'].setUrl(event.data.location)

          // _this.$refs['mobile'].go(event.data.location)
          //
          // if(!event.data.describe){
          //   return
          // }
          //
          // let options = _this.options
          // let position = null
          // for (var i = 0; i < options.length; i++) {
          //   let option = options[i]
          //   if(option.describe===event.data.describe){
          //     position = i
          //     break;
          //   }
          // }
          //
          //
          //
          // _this.position = position
          // _this.findBuriedPointEventDatas()
          break
        case 'buriedPoint':
          data.module = _this.module
          _this.$refs['save-x-path-dialog'].show(data)
          break
        case 'loading':
          _this.mobileLoding = true
          break
        case 'hideloading':
          _this.mobileLoding = false
          break
        case 'message':
          _this.$message.success(data.message)
          break
        default:
      }
    }, true)
  },
  methods: {
    onFinish: function () {
      this.playPosition = null
    },
    handleCurrentChange: function (pageNum) {
      this.pageNum = pageNum
      this.findBuriedPointEventDatas()
    },
    play: function (data) {
      // let _this = this
      //
      // let events = data.events
      // let pay = document.getElementById('iframe');
      //
      // pay.innerHTML = "";
      // const options = {
      //   root: pay,
      //   skipInactive: true
      // };
      // const replayer = new rrweb.Replayer(events,options);
      // replayer.on('start',function(){
      //   _this.mobileLoding = false
      // })
      // replayer.on('finish',function(){
      //   alert('播放完毕');
      // })
      // replayer.on('resize',function(e){
      //   console.log(e);
      // })
      //
      // replayer.play();

      this.$refs['player'].play(data.events)
    },
    onEdit: function () {
      let option = this.options[this.position]

      let data = {
        location: option.location,
        nativeLocation: option.nativeLocation,
        locationDescribe: option.xPath ? null : option.describe,
        xPath: option.xPath,
        nativeXPath: option.nativeXPath,
        xPathDescribe: option.xPath ? option.describe : null,
        _xPathId: option.xPath ? option._id : null,
        _locationId: option.xPath ? null : option._id
      }

      this.$refs['save-x-path-dialog'].show(data)
    },
    getDateTimeByUnixTime: function (time, format = '-') {
      if (!time) {
        return '无'
      }
      let unixtime = parseInt(time)

      let localeDate = new Date(unixtime)
      let year = localeDate.getFullYear()
      let month = localeDate.getMonth() + 1
      let day = localeDate.getDate()
      let hour = localeDate.getHours()
      let minutes = localeDate.getMinutes()
      let seconds = localeDate.getSeconds()
      let dateText = year + format + (month < 10 ? '0' + month : month) + format + (day < 10 ? '0' + day : day)
      dateText = dateText + ' ' + (hour < 10 ? '0' + hour : hour) + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds)
      return dateText
    },

    findBuriedPointEventDatas: function () {
      this.playPosition = null
      let _this = this
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        keyword: this.query.keyword
      }

      let listener = {
        success: (dataInfo) => {
          let datas = dataInfo.datas.datas
          let count = dataInfo.datas.count

          _this.datas = datas
          _this.totalSize = count
        }
      }

      BasicModel.get(this, '/main/findBuriedVideoEventDatas.action', params, listener)
    },
    replay: function (data, index) {
      this.playPosition = index

      this.mobileLoding = true
      let _this = this
      let params = {
        id: data._id
      }

      this.$refs['player'].start()

      let listener = {
        success: (dataInfo) => {
          let event = dataInfo.datas
          _this.play(event)
        }
      }

      BasicModel.get(this, '/main/findBuriedVideoEventInfo.action', params, listener)
    },
    filter: function (datas) {
      let counts = []
      for (var i = 0; i < this.times.length; i++) {
        let time = this.times[i]
        let count = 0
        for (var j = 0; j < datas.length; j++) {
          let item = datas[j]
          if (item._id == time) {
            count = item.count
            break
          }
        }
        counts.push(count)
      }

      this.datas = counts
    },
    init: function (id) {
      let _this = this
      let dom = document.getElementById(id)
      this.chart = echarts.init(dom)

      var colors = ['#5793f3', '#d14a61', '#675bba']

      let option = {
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            dataView: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.times
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          type: 'line',
          stack: '总量',
          smooth: true,
          data: this.datas
        }]
      }
      this.chart.clear()
      this.chart.setOption(option)
    },
    getXAxis: function (filters) {
      var tab = filters.tab
      var startTime = new Date(filters.startTime)
      var endTime = new Date(filters.endTime)

      var length = parseInt((endTime.getTime() - startTime.getTime()) / (1000 * 24 * 60 * 60) + 1)

      var xAxis = new Array(length)
      xAxis[0] = this.getMonthTimeByUnixTime(startTime)
      for (var i = 1; i < length; i++) {
        startTime.setDate(startTime.getDate() + 1)
        xAxis[i] = this.getMonthTimeByUnixTime(startTime)
      }

      return xAxis
    },
    getMonthTimeByUnixTime: function (localeDate, format = '-') {
      let year = localeDate.getFullYear()
      let month = localeDate.getMonth() + 1
      let day = localeDate.getDate()
      // let hour = localeDate.getHours()
      // let minutes = localeDate.getMinutes()
      // let seconds = localeDate.getSeconds()
      let dateText = year + '-' + (month < 10 ? '0' + month : month) + format + (day < 10 ? '0' + day : day)
      // dateText = dateText + ' ' + (hour < 10 ? '0' + hour : hour) + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds)
      return dateText
    }
  }
}

</script>
